import { Logo } from './Logo'
import classes from './LandingHeader.module.css'

export const LandingHeader = () => {
  return (
    <header className={classes.root}>
      <div className={classes.logo}>
        <Logo />
      </div>
    </header>
  )
}
